import React from 'react';
import classNames from 'classnames';
import { compose, defaultProps } from 'recompose';

import CircularProgress from '@material-ui/core/CircularProgress';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';

export interface LoaderProps {
  className?: string;
  size?: number;
  thickness?: number;
}

interface LoaderPrivateProps extends LoaderProps, WithStyles {}

const styles = () =>
  createStyles({
    loaderWrapper: {
      display: 'flex',
      flex: 1,
      minHeight: '100vh',
      alignSelf: 'center',
      alignItems: 'center',
      justifyContent: 'center',
    },
    root: {
      // ToDo: theme:
      // color: theme.color.primary.main,
    },
  });

const Loader: React.FunctionComponent<LoaderPrivateProps> = (props) => {
  const { size, thickness, classes, className: classNameProp, ...other } = props;
  const className = classNames(classes.root, classNameProp);
  return (
    <div className={classes.loaderWrapper} {...other}>
      <CircularProgress thickness={thickness} size={size} className={className} />
    </div>
  );
};

const ComposedLoader = compose<LoaderPrivateProps, LoaderProps>(
  withStyles(styles),
  defaultProps({
    size: 60,
    thickness: 1,
  }),
)(Loader);

ComposedLoader.displayName = 'Loader';

export default ComposedLoader;
